import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from '@material-ui/core'
import ExamStructure from './ExamStructure'
import Container from '@material-ui/core/Container'
import Navbar from '../../components/Navbar'
import Button from '@material-ui/core/Button'
import TopAndBottomBar from '../TopAndBottomBar'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useMutation, useQuery, useLazyQuery } from '@apollo/react-hooks';
import { examMutations } from '../../graphql/mutations'
import { userQueries } from '../../graphql/queries'
import { useHistory } from 'react-router-dom'
import ExamModal from './ExamModal'
import { useFakeLoading } from '../../hooks'
import * as loggerClient from '../../services/loggerClient'
import { examsPropertiesQueries } from '../../graphql/queries'

const useStyles = makeStyles({
    root: {
        marginBottom: 88,
        '@media (max-width: 1050px)': {
            minHeight: 'unset',
        }
    },
    skipButton: {
        border: '2px solid',
        padding: '5px 20px'
    },
    finishButton: {
        color: '#fff',
    },
    supportButton: {
        backgroundColor: '#3B86FF',
        color: '#fff',
        opacity: '1',
        alignSelf: 'center',
        '&:hover': {
            backgroundColor: '#3B86FF'
        }
    }
})

const NavigationBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center
`

const MobileActionButton = styled.div`
    @media(max-width: 1050px){
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 8px 0
    }
`

const AtividadeProva = ({ data, type, id }) => {
    const classes = useStyles()
    const { loading: questionLoading, startLoading: startQuestionLoading } = useFakeLoading()
    const [questionNumber, setQuestionNumber] = useState(0)
    const [remainingQuestions, setRemainingQuestions] = useState()
    const [confirmSubmit, setConfirmSubmit] = useState(true)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [answerList, setAnswerList] = useState({})
    const [questionsCounter, setQuestionsCounter] = useState()
    const [examType, setExamtype] = useState(type)
    const history = useHistory()
    const defaultBreakpoint = useMediaQuery('(min-width:1050px)')

    const { data: dataUser } = useQuery(userQueries.GET_USER)

    const [adicionaResultadoProva, { loading: resultLoading }] = useMutation(examMutations.SUBMIT_EXAM_ANSWERS, {
        onCompleted({ adicionaResultadoProva }) {
            history.push(`/resultados/${(adicionaResultadoProva || {})._id}`)
        }
    })

    const handleQuestionResult = (selectedAnswer) => {
        setAnswerList({ ...answerList, [selectedAnswer.pergunta]: selectedAnswer.resposta })
    }

    const getResponseUser = (responses) => {
        for (const item of responses) {
            if (item.selected === true) {
                return { resposta: item.numero, respostaId: item._id }
            }
        }

        return { resposta: undefined, respostaId: '' }
    }

    const handleExamNavigation = (step, data, dateStart) => {

        if (step === 'next') {
            const { resposta, respostaId } = getResponseUser(data.perguntas[questionNumber].respostas)
            let evento = ''

            if (resposta === undefined) {
                evento = 'pulo'
            } else {
                evento = null
            }

            const dataHora = parseInt(dateStart.dataInicio, 10)
            const newData = new Date(dataHora).toISOString()

            const origem = id
            const contexto = 'provas_simulados'
            const conteudo = ''
            const tipo = type
            const perguntaId = (data || {}).perguntas[questionNumber]._id

            loggerClient.onShowTestResult({
                conteudo: conteudo,
                pergunta: perguntaId,
                tipo: tipo,
                origem: origem,
                contexto: contexto,
                inicio: newData,
                evento: evento,
                resposta: respostaId
            })
        }

        step === 'next' ? setQuestionNumber(questionNumber + 1) : setQuestionNumber(questionNumber - 1)
    }

    const handleProgress = () => {
        setQuestionsCounter(Object.keys(answerList).length)
        setRemainingQuestions(((data || {}).perguntas || []).length - (Object.keys(answerList).length))
        remainingQuestions > 0 ? setConfirmSubmit(true) : setConfirmSubmit(false)
    }

    const submitResults = (data, dateStart) => {

        if (confirmSubmit && modalIsOpen === false) {

            const { resposta, respostaId } = getResponseUser(data.perguntas[questionNumber].respostas)
            let evento = ''

            if (resposta === undefined) {
                evento = 'pulo'
            } else {
                evento = null
            }

            const dataHora = parseInt(dateStart.dataInicio, 10)
            const newData = new Date(dataHora).toISOString()

            const origem = id
            const contexto = 'provas_simulados'
            const conteudo = ''
            const tipo = type
            const perguntaId = (data || {}).perguntas[questionNumber]._id

            loggerClient.onShowTestResult({
                conteudo: conteudo,
                pergunta: perguntaId,
                tipo: tipo,
                origem: origem,
                contexto: contexto,
                inicio: newData,
                evento: evento,
                resposta: respostaId
            })

            setModalIsOpen(true)
        } else {
            const perguntasRespondidas = Object.keys(answerList).map((item, index) => ({
                pergunta: item,
                resposta: Object.values(answerList)[index]
            }))
            createExamResult({ perguntasRespondidas, tipo: examType, prova_id: id })
        }
    }

    const createExamResult = (variables) => {
        adicionaResultadoProva({ variables })
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }

    useEffect(() => {
        handleProgress()
    })

    useEffect(() => {
        setRemainingQuestions(((data || {}).perguntas || []).length)
        if ((type || '') === 'Prova Personalizada') {
            setExamtype('provaPersonalizada')
        } else {
            setExamtype((type || '').toLowerCase())
        }
    }, []) //eslint-disable-line

    useEffect(startQuestionLoading, [questionNumber])

    const [loadDataInicio, { loading: loadingDataInicio, data: dataInicio }] = useLazyQuery(examsPropertiesQueries.GET_DATE_START, { fetchPolicy: "network-only" })

    useEffect(() => {
        loadDataInicio()
    }, [questionNumber]) //eslint-disable-line

    if (resultLoading || loadingDataInicio || !dataInicio) return null


    return (
        <>
            <Navbar type="examBar" counter={questionsCounter} remainingQuestions={remainingQuestions} />
            <Container className={classes.root}>
                <ExamStructure
                    type={type}
                    questionLoading={questionLoading}
                    content={(data || {})}
                    questionNumber={questionNumber}
                    answerList={answerList}
                    onChange={(t) => handleQuestionResult(t)}
                />
            </Container>
            <TopAndBottomBar bottomBar={true} smallBar={true}>
                <Container>
                    <NavigationBox>
                        {defaultBreakpoint ? <Typography gutterBottom variant="body1" component="span">
                            {questionNumber >= 0 ? `Pergunta ${questionNumber + 1} de ${((data || {}).perguntas || {}).length}` : `${((data || {}).perguntas || {}).length} perguntas`}
                        </Typography> : null}
                        <MobileActionButton>
                            <Button
                                onClick={() => handleExamNavigation('back', data, dataInicio)}
                                color="primary"
                                disabled={questionNumber < 1 ? true : false}
                                className={classes.skipButton}
                                style={{ fontSize: '14px', fontWeight: 400 }}
                                startIcon={<ArrowBackIosIcon style={{ fontSize: '14px' }} />}>
                                Anterior
                            </Button>
                            {questionNumber + 1 !== ((data || {}).perguntas || []).length ? <Button
                                onClick={() => handleExamNavigation('next', data, dataInicio)}
                                style={{ marginLeft: '20px', fontSize: '14px', fontWeight: 400 }}
                                className={classes.skipButton}
                                color="primary"
                                endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
                            >
                                Próximo
                            </Button> : <Button
                                    disabled={Object.keys(answerList).length === 0 ? true : false}
                                    onClick={() => submitResults(data, dataInicio)}
                                    style={{ marginLeft: '20px', fontSize: '14px', fontWeight: 400, width: 'auto' }}
                                    className={classes.finishButton}
                                    variant="contained"
                                    color="primary"
                                    endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
                                >
                                    Concluir
                            </Button>}
                        </MobileActionButton>
                        {defaultBreakpoint ? <Button
                            variant="outlined"
                            color="primary"
                            style={{ marginRight: '8px' }}
                            className={classes.supportButton}
                            href={`https://atendimento.manole.com.br/aprimora/?e=${btoa(((dataUser || {}).usuario || {}).email)}`}
                            rel="noopener"
                            startIcon={<RecordVoiceOverIcon style={{ fontSize: '16px' }} />}
                        >
                            Suporte
                        </Button> : null}
                    </NavigationBox>
                </Container>
            </TopAndBottomBar>
            <ExamModal
                open={modalIsOpen}
                onClose={closeModal}
                submit={() => submitResults()}
                remainingQuestions={remainingQuestions} />
        </>
    )
}

export default AtividadeProva